/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Banknote, FileCheck2, Landmark } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
import { Input } from '@/ui/base/input';
const NS = '/bff/v1/j08-s05-empenhar-liquidar';
const moeda = (v: any) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export function EmpenharLiquidarPage() {
  const [s, setS] = useState<any>(),
    [busy, setBusy] = useState(false),
    [saldo, setSaldo] = useState('1000');
  async function call(p: string, b?: any) {
    setBusy(true);
    try {
      const e = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
      setS(e.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando financeiro…
      </main>
    );
  const m = s.medicoes[0],
    d = s.dotacoes[0],
    e = s.empenhos[0];
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <Banknote className="mr-2 inline h-7 w-7" />
          {s.titulo}
        </h1>
        <p>{s.descricao}</p>
        <p className="text-sm text-muted-foreground">
          Sessão: {s.sessao?.nome} · {s.sessao?.email}
        </p>
      </header>
      {s.alertas.map((a: any) => (
        <div key={a.codigo} role="alert" className="rounded-md border border-destructive p-3">
          {a.mensagem} <span className="font-mono text-xs">{a.codigo}</span>
        </div>
      ))}
      {m && (
        <section className="grid gap-3 sm:grid-cols-3">
          <div className="rounded-md border p-4">
            <p>Medição</p>
            <strong>{m.credenciadoNome}</strong>
            <p>
              {m.competencia} · v{m.versao_atual}
            </p>
          </div>
          <div className="rounded-md border p-4">
            <p>Valor líquido</p>
            <strong>{moeda(m.liquido)}</strong>
            <p className="break-all font-mono text-xs">{m.hash}</p>
          </div>
          <div className="rounded-md border p-4">
            <p>Estado financeiro</p>
            <strong>{e?.estado ?? 'AGUARDA EMPENHO'}</strong>
          </div>
        </section>
      )}
      {m && !e && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">
            <Landmark className="mr-2 inline h-5 w-5" />
            Dotação e saldo
          </h2>
          <label htmlFor="saldo">Saldo disponível</label>
          <Input
            id="saldo"
            inputMode="decimal"
            value={saldo}
            onChange={(x) => setSaldo(x.target.value)}
          />
          <Button
            disabled={busy}
            onClick={() =>
              void call('/verbs/preparar_dotacao', {
                consolidacaoId: m.id,
                codigo: 'TEG-2026-TRANSPORTE',
                saldo: Number(saldo),
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            {d ? 'Atualizar dotação' : 'Disponibilizar dotação'}
          </Button>
        </section>
      )}
      {d && !e && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">Reserva de empenho</h2>
          <p>
            {d.codigo} · disponível {moeda(d.disponivel)}
          </p>
          <Button
            disabled={busy}
            onClick={() =>
              void call('/verbs/reservar_empenho', {
                consolidacaoId: m.id,
                dotacaoId: d.id,
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            Reservar empenho
          </Button>
        </section>
      )}
      {e && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">
            <FileCheck2 className="mr-2 inline h-5 w-5" />
            {e.numero}
          </h2>
          <p>
            {moeda(e.valor)} · {e.estado} · dotação {e.dotacao_codigo}
          </p>
          {e.documentos.map((x: any) => (
            <p key={x.id}>
              Documento {x.tipo} · hash{' '}
              <span className="break-all font-mono text-xs">{x.hash}</span>
            </p>
          ))}
          {!e.documentos.length && (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/anexar_documento', {
                  empenhoId: e.id,
                  tipo: 'DEMONSTRATIVO_PRELIMINAR',
                  referencia: `medicao:${m.id}:versao:${m.versaoId}`,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Anexar demonstrativo
            </Button>
          )}
          {e.estado === 'EMPENHADO' && (
            <Button
              disabled={busy}
              onClick={() =>
                void call('/verbs/confirmar_liquidacao', {
                  empenhoId: e.id,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Confirmar liquidação
            </Button>
          )}
          {e.lote && (
            <p role="status">
              Lote {e.lote.numero} · {e.lote.estado} · pronto para exportação
            </p>
          )}
        </section>
      )}
    </main>
  );
}
